<div class="main">
    <div class="row align-items-center wrapper">
        <div class="col-12 col-xl-6 ivlogo">
            <img src="../../../assets/images/iv_icono_rombo.svg" width="100%" alt="IvCert Logo">   
        </div>
        <div class="col-12 col-xl-6">
            <h1 class="title" [style.color]="'primary'|colors">{{ '404_number' | translate }}</h1>
            <h3 class="subtitle">{{ '404_title' | translate }}</h3>
            <p class="text">{{ '404_subtitle' | translate }}</p>
            <button mat-flat-button [color]="'material'|colors" [style.background-color]="'primary'|colors" [style.color]="'text'|colors" type="button" (click)="goToHome()" class="customButton">
                <span class="actionButtons">{{ '404_btn' | translate }}</span>
            </button>
        </div>
    </div>    
</div>
